import { render, staticRenderFns } from "./DigitalSignaturePopup.vue?vue&type=template&id=35eda740&"
import script from "./DigitalSignaturePopup.vue?vue&type=script&lang=js&"
export * from "./DigitalSignaturePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports